export enum HighTraffic {
  normal = 'normal',
  dirty = 'dirty'
}

export enum SmartCleanPipeline {
  rt_map = 'rt_map',
  rt_mission = 'rt_mission',
  batch_decay = 'batch_decay',
  batch_canned_data = 'batch_canned_data',
  insights_integration_test = 'insights_integration_test',
  qa_api = 'qa_api'
}

export class MissionInfo {
  public startTime: number;
  public nMssn: number;
  public missionId?: string;
}

export class PadWetness {
  disposable?: number;
  reusable?: number;
  padPlate?: number;
}

export class CleaningParameters {
  public operatingMode?: number = null;
  public twoPass?: boolean = null;
  public noAutoPasses?: boolean = null;
  public carpetBoost?: boolean = null;
  public vacHigh?: boolean = null;
  public gentleMode?: number = null;
  public padWetness?: PadWetness = null;
  public swScrub?: number = null;
  public suctionLevel?: number = null;
}

export class CleanScoreRegion {
  public region_id: string;
  public clean_score: number;
  public updated_ts: number;
  public last_updated_by: SmartCleanPipeline;
  public high_traffic_enum: HighTraffic;
  public mission_last_cleaned?: MissionInfo;
  public mission_last_unfinished?: MissionInfo;
  public smart_clean_prefs?: CleaningParameters;
}

export enum Command {
  start = 'start'
}

export enum CommandDefRegionType {
  rid = 'rid'
}

export class CommandDefRegion {
  public region_id: string;
  public type: CommandDefRegionType;
  public params?: CleaningParameters = null;
}

export class CommandDef {
  public id: string;
  public robot_id: string;
  public command: Command;
  public pmap_id: string;
  public ordered: number;
  public regions: CommandDefRegion[] = [];
  public smart_clean_id: string;
}

export class CleanScore {
  public pmap_id: string;
  public smart_clean_id: string;
  public active_pmapv_id?: string;
  public user_pmapv_id?: string;
  public mission_last_processed?: MissionInfo;
  public regions: CleanScoreRegion[] = [];
}

export enum ItemType {
  region_metadata = 'region_metadata',
  smart_clean_cmd = 'smart_clean_cmd',
  map_metadata = 'map_metadata'
}

export class DDBRegionsList {
  public pk: string;
  public last_updated_ts: number;
  public last_updated_by: SmartCleanPipeline;
  public created_on_ts: number;
  public created_by?: SmartCleanPipeline = null;
  public smart_clean_id: string;
  public robot_id: string;
  public robot_family?: string = null;
  public item_type: ItemType;
  public available_regions: string[];
  public mission_last_processed?: MissionInfo = null;
  public source_table_creation_ts_ms_pmap?: number = null;
  public source_table_creation_ts_ms_mission?: number = null;
  public pmap_id: string;
  public active_pmapv_id: string;
  public user_pmapv_id: string;
}

export class DDBCleanScoreRegion {
  public pk: string;
  public last_updated_ts: number;
  public last_updated_by: SmartCleanPipeline;
  public created_on_ts: number;
  public created_by?: SmartCleanPipeline = null;
  public robot_id: string;
  public robot_family?: string = null;
  public item_type: ItemType;
  public smart_clean_id: string;
  public region_score: number;
  public region_high_traffic_enum: HighTraffic;
  public region_mission_last_cleaned?: MissionInfo = null;
  public region_mission_last_unfinished?: MissionInfo = null;
  public region_type?: string = null;
  public params?: CleaningParameters = null;
  public name?: string = null;
  public pmap_id: string;
}

export class DDBSmartCleanCommand {
  public pk: string;
  public last_updated_ts: number;
  public last_updated_by: SmartCleanPipeline;
  public created_on_ts: number;
  public created_by?: SmartCleanPipeline = null;
  public robot_id: string;
  public robot_family?: string = null;
  public item_type: ItemType;
  public smart_clean_id: string;
  public pmap_id: string;
  public commanddefs: CommandDef[] = [];
}

export class QARegionItem {
  public region_id: string;
  public clean_score: number;
}

export class QACleanScoreItem {
  public pmap_id: string;
  public regions: QARegionItem[] = [];
}

export class QACleanScoreP2mapItem {
  public p2map_id: string;
  public regions: QARegionItem[] = [];
}
